export default (function (_ref) {
  var request = _ref.request;
  return {
    feedBaitAdd: function feedBaitAdd(data) {
      return request({
        url: '/feed/fdrDevice',
        method: 'post',
        data: data,
        service: 'iot'
      });
    },
    feedBaitModify: function feedBaitModify(data) {
      return request({
        url: "/feed/fdrDevice/".concat(data.id),
        method: 'put',
        data: data,
        service: 'iot'
      });
    },
    feedBaitDel: function feedBaitDel(id) {
      return request({
        url: "/feed/fdrDevice/".concat(id),
        method: 'delete',
        service: 'iot'
      });
    },
    feedBaitQueryJoinLab: function feedBaitQueryJoinLab(data) {
      return request({
        url: '/feed/fdrDevice/queryJoinLab',
        method: 'get',
        params: data,
        service: 'iot'
      });
    },
    feedBaitDetail: function feedBaitDetail(id) {
      return request({
        url: "/feed/fdrDevice/".concat(id),
        method: 'get',
        service: 'iot'
      });
    }
  };
});